























































import { Component, Prop, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import UtilMixin from "@/mixins/utilMixin";
import SearchBase from "@/components/admin_common/SearchBase.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { PortalJobsearchApplication } from "@/model/portal";
import { PORTAL_JOBSEARCH_APPLICATION_SELECTION_STATUS } from "@/consts/portal";

@Component({
  components: {
    AppTextField,
    SearchBase,
    AppAuthButton,
  },
})
export default class extends Mixins(AxiosMixin, UtilMixin) {
  private searchKey = ""; //絞り込み文字列
  private selectionStatusOptions =
    PORTAL_JOBSEARCH_APPLICATION_SELECTION_STATUS;

  /** 求人情報 */
  @Prop({
    type: Array,
    default: () => [],
  })
  readonly items!: PortalJobsearchApplication[];

  private headers = [
    { text: "詳細", value: "action" },
    { text: "求人ID", value: "jobsearch_listing_id" },
    { text: "求人タイトル", value: "jobsearch_listing_title" },
    { text: "事業所番号（HST）", value: "hst_no" },
    { text: "事業所名", value: "portal_office_name" },
    { text: "応募者名", value: "recruitee_name" },
    { text: "応募者番号（JST）", value: "jst_no" },
    { text: "選考ステータス", value: "selection_status_label" },
  ];

  /** 詳細ボタンクリック時 */
  private goDetail(id: number) {
    /** 詳細画面へ遷移 */
    this.$router.push({
      path: `/jobsearch/jobsearch-application/detail/${id}`,
    });
  }
}
